export default function (context, val) {
    let ags = {};
    val.agreements.forEach(i => {
        ags[i] = true;
    });
    context.state.list.forEach(i => {
        if (i.value === val.value) return;
        i.agreements.forEach(j => {
            if (ags[j]) ags[j] = false;
        });
    });
    for (let k in ags) {
        if (ags[k]) {
            context.dispatch('finances/pay/agreement_remove', '' + k, {root: true});
        }
    }
}